<template>
  <div class="product-category-detail">
    <a-card>
      <div class="detail-header">
        <div class="tabs">
          <a-tag color="#1677ff" style="font-size:16px;">产品品类详情</a-tag>
        </div>
      </div>
      <a-tabs v-model:activeKey="tabKey" style="margin-top: 12px;">
        <a-tab-pane key="info" tab="产品品类信息">
          <div class="info-block">
            <div class="info-left">
              <div class="info-row">
                <span class="tab-btn" :class="{active: tabKey==='info'}">{{ detail.name }}</span>
              </div>
            </div>
            <div class="info-right">
              <a-button type="default" @click="goEdit" style="margin-left: 16px;"><template #icon><EditOutlined /></template>编辑</a-button>
            </div>
          </div>
          <div class="info-card">
            <div class="info-img">
              <a-image :width="120" :height="120" :preview="false" src="https://img.icons8.com/ios/100/000000/image.png" />
            </div>
            <div class="info-table">
              <div class="info-row">
                <span class="info-label">产品品类名称</span>
                <span class="info-value">{{ detail.name }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">描述</span>
                <span class="info-value">{{ detail.desc }}</span>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="model" tab="物模型">
          <div class="model-panel">
            <!-- 查询区 -->
            <div class="model-search-bar">
              <a-form layout="inline">
                <a-form-item label="标识符">
                  <a-input placeholder="请输入标识符" style="width:180px;" />
                </a-form-item>
                <a-form-item label="类型">
                  <a-select placeholder="请选择类型" style="width:120px;">
                    <a-select-option value="">全部</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item>
                  <a-button type="primary" style="margin-right:8px;">查询</a-button>
                  <a-button>重置</a-button>
                </a-form-item>
              </a-form>
            </div>
            <!-- 按钮区 -->
            <div class="model-btn-bar">
              <a-button type="primary">快捷标准功能</a-button>
              <a-button type="primary">批量删除</a-button>
              <a-button type="primary">全部物模型</a-button>
            </div>
            <!-- 表格区 -->
            <div class="model-table-bar">
              <div class="table-tools">
                <a-button type="text"><template #icon><i class="fa fa-refresh" /></template></a-button>
                <a-button type="text"><template #icon><i class="fa fa-th-large" /></template></a-button>
                <a-button type="text"><template #icon><i class="fa fa-list" /></template></a-button>
                <a-button type="text"><template #icon><i class="fa fa-expand" /></template></a-button>
              </div>
            </div>
            <div class="lowcode-bar" style="margin-bottom: 16px;">
              <a-button type="primary" @click="goLowcode">低代码</a-button>
            </div>
            <a-table :columns="modelColumns" :data-source="[]" :pagination="false" style="margin-top: 8px;">
              <template #emptyText>
                <div style="text-align:center;padding:32px 0;">
                  <a-empty description="暂无数据" />
                </div>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { EditOutlined } from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()
const tabKey = ref('info')

// 模拟数据，实际可根据route.params.id请求
const detail = ref({
  name: '传感器设备',
  desc: '传感器相关设备',
  image: ''
})

function goEdit() {
  // 编辑逻辑
}

function goLowcode() {
  router.push('/lowcode')
}

const modelColumns = [
  { title: '功能类型', dataIndex: 'type', key: 'type' },
  { title: '功能名称', dataIndex: 'name', key: 'name' },
  { title: '标识符', dataIndex: 'identifier', key: 'identifier' },
  { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
  { title: '读写类型', dataIndex: 'accessType', key: 'accessType' },
  { title: '数据定义', dataIndex: 'definition', key: 'definition' },
  { title: '操作', key: 'action' }
]

const selectedKeys = ref(['sync'])
const openKeys = ref(['system'])

function onMenuSelect({ key }: { key: string }) {
  selectedKeys.value = [key]
  if (key === 'feedback') router.push('/system/systemConfig/feedback')
  if (key === 'user-mgr') router.push('/system/systemConfig/user-mgr')
  if (key === 'sync') router.push('/system/systemConfig/sync')
  // 其它菜单可按需跳转
}
</script>

<style lang="less" scoped>
.product-category-detail {
  .detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tabs {
      display: flex;
      align-items: center;
    }
  }
  .info-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fafbfc;
    padding: 16px 24px;
    border-radius: 4px;
    margin-bottom: 12px;
    .info-left {
      flex: 1;
      .info-row {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .info-right {
      .tab-btn {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        background: #f5f5f5;
        border-radius: 4px;
        padding: 4px 16px;
        &.active {
          color: #1677ff;
          background: #e6f7ff;
        }
      }
    }
  }
  .info-card {
    display: flex;
    background: #fafbfc;
    border-radius: 4px;
    padding: 32px 24px;
    .info-img {
      width: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .info-table {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .info-row {
        display: flex;
        margin-bottom: 24px;
        .info-label {
          width: 120px;
          color: #888;
          font-size: 16px;
        }
        .info-value {
          font-size: 16px;
          color: #222;
        }
      }
    }
  }
  .model-panel {
    background: #fff;
    border-radius: 4px;
    margin-top: 12px;
    padding: 0 0 16px 0;
    .model-search-bar {
      padding: 16px 0 0 0;
      background: #fff;
    }
    .model-btn-bar {
      display: flex;
      gap: 12px;
      margin: 16px 0 0 0;
      padding-left: 0;
    }
    .model-table-bar {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 8px 0 0 0;
      .table-tools {
        display: flex;
        gap: 8px;
      }
    }
  }
}
</style> 